import React, { useEffect, useState } from "react";
import "./add-item-modal.css";
import { showToast } from "../toasts/ToastNotification";
import { ClipLoader } from "react-spinners";
import { updatePackageInformation } from "../../api/product.api";

const ChangePackageInformationModal = ({
    productId,
    isOpen,
    onClose,
    title,
    packageId,
    pack_name,
    pack_price,
    fetchData
}) => {
    const [packName, setPackName] = useState("");
    const [packPrice, setPackPrice] = useState(0);
    const [loading, setLoading] = useState(false);

    const handleChange = async () => {
        
        if (packName.trim() == "") showToast("Vui lòng nhập tên gói nạp", "error");
        if (packPrice <= 0) showToast("Vui lòng nhập giá gói nạp", "error");

        try {
            setLoading(true);

            const resp = await updatePackageInformation(
                productId,
                packageId,
                packName,
                packPrice
            );

            if (resp.success) {
                fetchData();
                onClose();
            }
        } catch (error) {
            showToast(error.message, "error");
        }
        finally {
            setLoading(false);
        }
    }
    
    if (!isOpen) return null;

    return (
        <div className="add-item-modal-overlay" onClick={onClose} role="presentation">
            <div
                className="add-item-modal-content"
                onClick={(e) => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
            >
                <h2 className="add-item-modal-title">{ title}</h2>
                
                <div className="change-package-info-container">
                    <input
                        type="text"
                        className="change-package-info-input"
                        value={packName}
                        placeholder={pack_name}
                        onChange={(e) => setPackName(e.target.value)}
                    />

                    <input
                        type="text"
                        className="change-package-info-input"
                        value={packPrice}
                        placeholder={pack_price}
                        onChange={(e) => setPackPrice(Number(e.target.value.replace(/\D/g, '')))}
                    />
                </div>
                
                <div className="add-item-modal-buttons">
                    <button disabled={loading} className="cancel-btn" onClick={onClose}>Hủy</button>
                    <button disabled={loading}
                        className="confirm-btn update-button"
                        onClick={handleChange}
                    >{loading ? <ClipLoader size={20} color="#fff" /> : "Cập nhật"}</button>
                </div>
            </div>
        </div>
    );
};

export default ChangePackageInformationModal;
